<app-page-meta pageTitle="finzy - Loans"></app-page-meta>
<section class="page-wrapper">
    <section class="header-wrapper">
        <h4 class="header-topic">
            All Invested Loans
        </h4>
        <span class="header-detail">
            Below are the list of loans you have invested in.
        </span>
    </section>
    <section class="bg-grey d-flex justify-content-between p-4 mt-4" *ngIf="loanSettlementNegotiation?.settledLoansDetails?.length">
        <h4 class="font-weight-bold">Settlement requests ({{loanSettlementNegotiation?.settledLoansDetails?.length}})</h4>
        <a [routerLink]="['settlement']">
            <button mat-flat-button class="primary stroke-btn mat-primary mx-md-5 width-auto"
                (click)="navigateToLoanSettlementPage()">
                Loans Settlement
            </button>
        </a>
    </section>
    <section class="filter-wrapper">
        <div class="search-filter">
            <label class="search-label" for="product-type">Search with loan Id</label>
            <div class="search-container">
                <form class="search-form">
                    <img class="search-icon" src="../../../../../../assets/images/finzy-flex/search.svg" />
                    <input type="text" (input)="searchLoanById($event.target.value)" placeholder="Search By Loan ID"
                        class="search-box" />
                </form>
            </div>
        </div>
        <div class="product-filter">
            <label class="product-type-txt" for="product-type">Select Product Type</label>
            <div class="product-dropdown">
                <mat-icon class="dropdown-icon">keyboard_arrow_down</mat-icon>
                <mat-select [(ngModel)]="selectedProductType" (selectionChange)="filterByProductCode($event.value)"
                    class="product-select">
                    <mat-option *ngFor="let product of productTypes" [value]="product">
                        {{product}}
                    </mat-option>
                </mat-select>
            </div>
        </div>
        <div class="date-filter">
            <label class="date-range-txt" for="date-range">Date Range</label>
            <div class="date-range">
                <div class="from-date">
                    <mat-datepicker #fromDate></mat-datepicker>
                    <div class="group-icon-input">
                        <img class="calender-icon" alt="calender-icon"
                            src="../../../../../../assets/images/finzy-flex/calender_icon.svg"
                            (click)="fromDate.open()" />
                        <input class="input-from-date" [(ngModel)]="fromDateSelected"
                            (ngModelChange)="dateFilter('fromDate', $event)" [placeholder]="fromDatePlaceHolder"
                            matInput [matDatepicker]="fromDate" readonly>
                    </div>
                </div>
                <span class="to-text">To</span>
                <div class="from-date">
                    <mat-datepicker #toDate></mat-datepicker>
                    <div class="group-icon-input">
                        <img class="calender-icon" alt="calender-icon"
                            src="../../../../../../assets/images/finzy-flex/calender_icon.svg"
                            (click)="toDate.open()" />
                        <input class="input-from-date" [(ngModel)]="toDateSelected"
                            (ngModelChange)="dateFilter('toDate', $event)" [placeholder]="toDatePlaceholder" matInput
                            [matDatepicker]="toDate" readonly>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="table-wrapper">
        <mat-spinner *ngIf="!this.duplicateLoansList" class="spinner" [diameter]="35"></mat-spinner>
        <app-loan-table *ngIf="this.duplicateLoansList?.data.length > 0" [loans]="duplicateLoansList.data"
            (sort)="sorting($event)"></app-loan-table>
        <span *ngIf="loansList && this.loansList?.data.length <= 0" class="no-data-txt"> Data Not Found</span>
    </section>
    <section *ngIf="this.loansList?.data.length > 0" class="pagination-wrapper">
        <div class="page-numbers">
            <mat-paginator paginator-style (page)="pageChangeEvent($event)" [length]="pageLength" [pageSize]="pageSize"
                [showTotalPages]="showTotalPages" [pageSizeOptions]="[10, 20, 50]">
            </mat-paginator>
        </div>
    </section>
</section>